import { MarketingRepo } from '@core/repositories'
const resource = 'analytics/erfm_reports'

export default {
  getGroupAliases (config) {
    return MarketingRepo.get(`${resource}/group_aliases.json`, config)
  },
}
